import * as React from 'react';
/**
 *
 * Original name: Gmail
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=14398%3A2
 *
 */
export const GmailExternalLogo = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M20 7.639c0-1.349-1.54-2.118-2.618-1.309L12 10.366 6.618 6.33C5.538 5.521 4 6.29 4 7.64v9.27c0 .603.49 1.09 1.09 1.09h1.99v-7.415l4.913 3.74 4.926-3.738V18h1.99A1.09 1.09 0 0 0 20 16.91V7.638Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
